import React, { Fragment, useState, type PropsWithChildren} from "react";
import {IS_SECRET} from "modules";
import {SecretModal} from "components/HOCSecretKey/SecretModal";
import {Storage} from "modules/utils";
import {SecondarySecretModal} from "components/HOCSecretKey/SecondarySecretModal";

const STORAGE_SECRET_KEY = "secretPassed";
const SECONDARY_SECRET_KEY = "secondarySecretPassed";

const storageSecret = Storage.GET(STORAGE_SECRET_KEY);
const secondarySecret = Storage.GET(SECONDARY_SECRET_KEY);

export const HOCSecretKey: React.FC<PropsWithChildren> = (props) => {
	const [enabled, setEnabled] = useState(IS_SECRET && !storageSecret);

	const onPass = () => {
		Storage.SET(STORAGE_SECRET_KEY, true);
		setEnabled(false);
	};

	if (enabled) {
		return (
			<Fragment>
				<SecretModal onPass={onPass} />
			</Fragment>
		);
	}

	return <Fragment>{props.children}</Fragment>;
};

export const HOCSecondarySecretKey: React.FC<PropsWithChildren> = (props) => {
	if (IS_SECRET && !secondarySecret) {
		return (
			<Fragment>
				<SecondarySecretModal />
			</Fragment>
		);
	}

	return <Fragment>{props.children}</Fragment>;
};
